import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Button } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

import GridListItem from "components/common/grid/GridListItem";
import useBillingSchedule from "components/pages/transmissions/modal/patient/tabs/generalInformation/billingSchedule/useBillingSchedule";

import { showToast } from "utils/toast";
import { getMappedBillingCode } from "utils/billingCode.util";

import BillingScheduleForm from "./BillingScheduleForm";

const BillingSchedule = (props) => {
  const { originalBillingSchedule } = useSelector(
    (state) => state.transmission
  );

  const {
    isEditMode,
    isIDTFBilling,
    newBillingSchedule,
    setIsEditMode,
    handleBillingSchedule,
  } = useBillingSchedule();

  const [isLoading, setIsLoading] = useState(false);

  const handleBillingScheduleUpdate = async () => {
    try {
      setIsLoading(true);
      const response = await handleBillingSchedule(originalBillingSchedule);
      if (!response.error) {
        setIsEditMode(false);
      }
    } catch (error) {
      showToast({ message: error.message, type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="patient-form__row patient-form__info patient-modal__aside-container mb-3">
        <Grid container>
          <Grid item xs={11} style={{ textAlign: "left" }}>
            <div className="patient-form__info--header">
              Schedule — Billing Cycle
            </div>
          </Grid>
          {!isEditMode && (
            <Grid item xs={1} style={{ textAlign: "right" }}>
              <Button
                variant="text"
                color="secondary"
                className="profile-edit-button"
                onClick={() => setIsEditMode(true)}
              >
                <EditIcon
                  className="patient-edit-icon billing-cycle-edit-icon"
                  data-action="edit-schedule-billing-cycle-icon"
                />
                Edit
              </Button>
            </Grid>
          )}
        </Grid>
        {isEditMode ? (
          <BillingScheduleForm
            isLoading={isLoading}
            handleSubmit={handleBillingScheduleUpdate}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
          />
        ) : (
          <>
            <Grid container columnSpacing={2} className="view-pdf__drawer-grid">
              <Grid container item rowSpacing={2}>
                <GridListItem
                  size={3}
                  title="31 DAY BILLING CODE"
                  subTitle={
                    (newBillingSchedule.day31 &&
                      getMappedBillingCode({
                        billingCode: newBillingSchedule.day31BillingCode,
                        isIDTFBilling,
                      })) ??
                    "—"
                  }
                />
                <GridListItem
                  size={3}
                  title="91 DAY BILLING CODE"
                  subTitle={
                    (newBillingSchedule.day91 &&
                      getMappedBillingCode({
                        billingCode: newBillingSchedule.day91BillingCode,
                        isIDTFBilling,
                      })) ??
                    "—"
                  }
                />
                <GridListItem
                  size={3}
                  title="CUSTOM DAYS"
                  subTitle={
                    (newBillingSchedule.custom.enabled &&
                      newBillingSchedule.custom.days) ??
                    "—"
                  }
                />
                <GridListItem
                  size={3}
                  title="CUSTOM BILLING CODE"
                  subTitle={
                    (newBillingSchedule.custom.enabled &&
                      getMappedBillingCode({
                        billingCode:
                          newBillingSchedule.custom.customBillingCode,
                        isIDTFBilling,
                      })) ??
                    "—"
                  }
                />
              </Grid>
            </Grid>
          </>
        )}
      </div>
    </>
  );
};

export default BillingSchedule;
